export default {
    SERVICE_SERVER_ERROR: 'Data incorrect',
    BAD_REQUEST: 'Error. Try again',
    DNS_RECORD_EXIST: 'Record exist',
    EMPTY_DATA: 'There is no data',
    NAMESERVER_EXIST: 'Nameserver already exist',
    EMAIL_FORWARDING_RECORD_EXIST: 'Email forward already exist',
    EMAIL_TYPE_NOT_SUPPORT: 'Invalid email',
    EMAIL_FORWARDING_MAX: 'Max records',
    EMAIL_FORWARDING_NOT_EXIST: 'Email forward does not exist',
    DNS_NOT_FOUND: 'Record does not exist',
    EMAIL_EXISTS: 'Email already exists',
    CLOUD_SERVER_SETTING_UP:
        "Can't change Operating System when server is setting up",
    AMOUNT_EXCEEDED_LIMIT: 'Balance is insufficient for a withdrawal',
    NAMESERVER_INCORRECT: 'Nameserver is incorrect',
    SMS_TEMPLATE_NOT_FOUND: 'SMS template not found',
    BRAND_NAME_EXISTED: 'Brandname already exists',
    BALANCE_NOT_ENOUGH: 'Your balance is not enough',
    SMS_TRANSACTION_NOT_FOUND: 'Transaction is not found',
    REFUND_NOT_FOUND: 'Manual transaction refund is not found',
    CANT_SET_TEMPLATE: "Can't set template",
    SERVICE_UNAVAILABLE_TO_RENEW: 'Service unavailable to renew',
    SHARED_HOSTING_NOT_FOUND: 'Shared hosting is not found',
    CLOUD_HOSTING_IS_DELETED: 'Cloud hosting is deleted',
    CLOUD_HOSTING_IS_STOPPED: 'Cloud hosting is stopped',
    CLOUD_HOSTING_IS_SUSPENDED: 'Cloud hosting is suspended',
    CLOUD_SERVER_IS_DELETED: 'Cloud server is deleted',
    CLOUD_SERVER_IS_SUSPENDED: 'Cloud Server is suspended',
    PRIMARY_DOMAIN_NOT_AVAILABLE:
        'This was connected with another Cloud Hosting or Shared Hosting',
    INCORRECT_OTP: 'OTP code is incorrect',
    CLOUD_HOSTING_NOT_FOUND: 'Cloud Hosting not found',
    CLOUD_SERVER_NOT_FOUND: 'Cloud Server not found',
    SERVICE_CAN_NOT_UPGRADE: 'Unable to upgrade Cloud Service',
    ADDON_IS_REQUIRED: 'Unable to upgrade Cloud Service',
    PACKAGE_NOT_FOUND: 'Unable to upgrade Cloud Service',
    PACKAGE_MUST_BE_HIGHER: 'Unable to upgrade Cloud Service',
    ADDON_MUST_BE_HIGHER: 'Unable to upgrade Cloud Service',
    DURATION_IS_REQUIRED: 'Unable to upgrade Cloud Service',
    CARD_NOT_FOUND: 'The card is not found',
    CAN_NOT_DELETE_CARD: 'The card cannot be deleted',
    EMAIL_SETTING_NOT_FOUND: 'This email setting is not found',
    EMAIL_TYPE_INVALID: 'Invalid email setting type',
    CARD_NOT_ACCEPTED:
        "This card is not accepted. We don't accept cards without 3D Secure (3DS) enabled.",
    BRAND_NAME_IS_NOT_ASSIGNED:
        'This brandname does not belong to your account anymore',
    SMS_SCHEDULE_INCORRECT: 'SMS Schedule is not found',
    INVOICE_VAT_NOT_FOUND: 'This VAT invoice is not found',
    PHONE_EXISTS:
        'This phone number has already been assigned to another user.',
    CARD_DECLINED: {
        AUTHENTICATION_REQUIRED:
            'The card was declined as the transaction requires authentication.',
        APPROVE_WITH_ID: 'The payment can’t be authorized.',
        CALL_ISSUER: 'The card was declined for an unknown reason.',
        CARD_NOT_SUPPORTED: 'The card does not support this type of purchase.',
        CARD_VELOCITY_EXCEEDED:
            'The customer has exceeded the balance or credit limit available on their card.',
        CURRENCY_NOT_SUPPORTED:
            'The card does not support the specified currency.',
        DO_NOT_HONOR: 'The card was declined for an unknown reason.',
        DO_NOT_TRY_AGAIN: 'The card was declined for an unknown reason.',
        DUPLICATE_TRANSACTION:
            'A transaction with identical amount and credit card information was submitted very recently.',
        EXPIRED_CARD: 'The card has expired.',
        FRAUDULENT:
            'The payment was declined because Stripe suspects that it’s fraudulent.',
        GENERIC_DECLINE:
            'The card was declined for an unknown reason or possibly triggered by a blocked payment rule.',
        INCORRECT_NUMBER: 'The card number is incorrect.',
        INCORRECT_CVC: 'The CVC number is incorrect.',
        INCORRECT_PIN:
            'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.',
        INCORRECT_ZIP: 'The postal code is incorrect.',
        INSUFFICIENT_FUNDS:
            'The card has insufficient funds to complete the purchase.',
        INVALID_ACCOUNT:
            'The card, or account the card is connected to, is invalid.',
        INVALID_AMOUNT:
            'The payment amount is invalid, or exceeds the amount that’s allowed.',
        INVALID_CVC: 'The CVC number is incorrect.',
        INVALID_EXPIRY_MONTH: 'The expiration month is invalid.',
        INVALID_EXPIRY_YEAR: 'The expiration year is invalid.',
        INVALID_NUMBER: 'The card number is incorrect.',
        INVALID_PIN:
            'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.',
        ISSUER_NOT_AVAILABLE:
            'The card issuer couldn’t be reached, so the payment couldn’t be authorized.',
        LOST_CARD:
            'The payment was declined because the card is reported lost.',
        MERCHANT_BLACKLIST:
            'The payment was declined because it matches a value on the Stripe user’s block list.',
        NEW_ACCOUNT_INFORMATION_AVAILABLE:
            'The card, or account the card is connected to, is invalid.',
        NO_ACTION_TAKEN: 'The card was declined for an unknown reason.',
        not_permitted: 'The payment isn’t permitted.',
        OFFLINE_PIN_REQUIRED:
            'The card was declined because it requires a PIN.',
        ONLINE_OR_OFFLINE_PIN_REQUIRED:
            'The card was declined as it requires a PIN.',
        PICKUP_CARD:
            'The customer can’t use this card to make this payment (it’s possible it was reported lost or stolen).',
        PIN_TRY_EXCEEDED: 'The allowable number of PIN tries was exceeded.',
        PROCESSING_ERROR: 'An error occurred while processing the card.',
        REENTER_TRANSACTION:
            'The payment couldn’t be processed by the issuer for an unknown reason.',
        RESTRICTED_CARD:
            'The customer can’t use this card to make this payment (it’s possible it was reported lost or stolen).',
        REVOCATION_OF_ALL_AUTHORIZATIONS:
            'The card was declined for an unknown reason.',
        REVOCATION_OF_AUTHORIZATION:
            'The card was declined for an unknown reason.',
        SECURITY_VIOLATION: 'The card was declined for an unknown reason.',
        SERVICE_NOT_ALLOWED: 'The card was declined for an unknown reason.',
        STOLEN_CARD:
            'The payment was declined because the card is reported stolen.',
        STOP_PAYMENT_ORDER: 'The card was declined for an unknown reason.',
        TESTMODE_DECLINE: 'A Stripe test card number was used.',
        TRANSACTION_NOT_ALLOWED: 'The card was declined for an unknown reason.',
        TRY_AGAIN_LATER: 'The card was declined for an unknown reason.',
        WITHDRAWAL_COUNT_LIMIT_EXCEEDED:
            'The customer has exceeded the balance or credit limit available on their card.',
    },
    EXPIRED_CARD:
        'The card has expired. Check the expiration date or use a different card.',
    INCORRECT_CVC:
        'The card’s security code is incorrect. Check the card’s security code or use a different card.',
    PROCESSING_ERROR:
        'An error occurred while processing the card. Try again later or with a different payment method.',
    INCORRECT_NUMBER:
        'The card number is incorrect. Check the card’s number or use a different card.',
    ACCOUNT_BANNED: 'Account banned',
    REQUIRED_USERNAME: 'A valid username is required',
    REQUIRED_PASSWORD: 'A valid password is required',
    USERNAME_PASSWORD_INCORRECT: 'Username or Password is incorrect',
    AWS_ACCOUNT_NOT_FOUND: 'AWS Account not found.',
    INVALID_2FA_STATUS: 'Invalid 2FA Status',
    WORDPRESS_HOSTING_NOT_AVAILABLE: 'WordPress Hosting not available',
    FAILED_PROGRESS: 'An error occurred during the process',
    LOCKED_UPDATE_SSL: 'System being processed your SSL configuration.',
    WORDPRESS_HOSTING_NO_SPACE:
        'You do not have sufficient space to upgrade this installation',
    ORDER_NOT_FOUND: 'Your order not found',
    ORDER_STATUS_INVALID: 'Your invoice has been paid',
    INVOICE_PROCESSED:
        'Your invoice is currently being processed. Thank you for your patience',
    CANNOT_SAVE_PAYMENT_INFO_FOR_ORDER:
        'Your invoice is currently being processed. Thank you for your patience',
    CANNOT_COMPLETE_PAYMENT:
        'Please try again later in the dashboard, invoice section',
    INVALID_REQUEST_EXCEEDS_AUTH_AMOUNT:
        'Decline - The requested amount exceeds the originally authorized amount. Occurs, for example, if you try to capture an amount larger than the original authorization amount.',
    PAYMENT_GATEWAY_ERROR:
        'Error {errorCode}, please try again, if this still happens, please contact support.',
    PAYMENT_PROCESSOR_ERROR:
        'Error {errorCode}, please try again, if this still happens, please contact support.',
    PARAMETER_INVALID_EMPTY:
        'Error {errorCode}, please try again, if this still happens, please contact support.',
    DECLINED_EXPIRED_CARD:
        'Decline - Expired card. You might also receive this if the expiration date you provided does not match the date the issuing bank has on file. Request a different card or other form of payment.',
    DECLINED_PROCESSOR_DECLINED:
        'Decline - General decline of the card. No other information provided by the issuing bank. Request a different card or other form of payment.',
    DECLINED_INSUFFICIENT_FUND:
        'Decline - Insufficient funds in the account. Request a different card or other form of payment.',
    DECLINED_STOLEN_LOST_CARD:
        'Decline - Stolen or lost card. Refer the transaction to your customer support center for manual review.',
    DECLINED_ISSUER_UNAVAILABLE:
        'Decline - Issuing bank unavailable. Wait a few minutes and resend the request.',
    DECLINED_UNAUTHORIZED_CARD:
        'Decline - Inactive card or card not authorized for card-not-present transactions. Request a different card or other form of payment.',
    DECLINED_CVN_NOT_MATCH:
        'Decline - card verification number (CVN) did not match. Request a different card or other form of payment.',
    DECLINED_EXCEEDS_CREDIT_LIMIT:
        'Decline - The card has reached the credit limit. Request a different card or other form of payment.',
    DECLINED_INVALID_CVN:
        'Decline - Invalid Card Verification Number (CVN). Request a different card or other form of payment.',
    DECLINED_DECLINED_CHECK:
        'Decline - Generic Decline. Request a different form of payment.',
    DECLINED_BLACKLISTED_CUSTOMER:
        "Decline - The customer matched an entry on the processor's negative file. Review the order and contact the payment processor.",
    DECLINED_SUSPENDED_ACCOUNT:
        "Decline - customer's account is frozen Review the order or request a different form of payment.",
    DECLINED_INVALID_ACCOUNT:
        'Decline - Invalid account number Request a different card or other form of payment.',
    INVALID_REQUEST_CARD_TYPE_NOT_ACCEPTED:
        'Decline - The card type is not accepted by the payment processor. Contact your merchant bank to confirm that your account is set up to receive the card in question.',
    DECLINED_GENERAL_DECLINE:
        'Decline - General decline by the processor. Request a different card or other form of payment.',
    INVALID_REQUEST_PROCESSOR_UNAVAILABLE:
        'Decline - Processor failure. Wait a few minutes and resend the request.',
    INVALID_REQUEST_INVALID_CARD_TYPE:
        'Decline - The card type sent is invalid or does not correlate with the credit card number. Confirm that the card type correlates with the credit card number specified in the request, then resend the request.',
    CHECKOUT_REACHED_LIMIT_PURCHASE_SERVICE:
        'Each user can have a maximum of 10 active baby cloud. Please purchase other packages and remove baby cloud from your cart',
    PAYMENT_INTENT_AUTHENTICATION_FAILURE:
        'We are unable to authenticate your payment method. Please choose a different payment method and try again.',
    REQUIRED_DOMAIN: 'Please enter domain name',
    INVALID_SUBDOMAIN: 'Please enter a valid subdomain',
    CLOUD_HOSTING_IS_SETTING_UP: 'Cloud Hosting is setting up',
    MAX_PASSWORD_REGISTER: 'Password must be from {from} to {to} characters',
    SAME_PASSWORD_REGISTER:
        'Oops, that’s not the same password as the first one.',
    INVALID_PASSWORD:
        'Invalid password, password only accepts alphabet, number and special characters',
    INVALID_PASSWORD_REGISTER:
        'Password must have at least one uppercase letter, one lowercase letter, one number',
    DOWNLOAD_AN_SSL_CERTIFICATE_FAILED: 'Download cert failed.',
    EMAIL_NOT_CHANGE: 'New email is not different with current email',
    ACTIVITY_LOG_NOT_FOUND: 'Activity log not found',
    INVALID_CLOUD_SERVER_JOB_STATUS: 'Invalid cloud server job status',
    ENABLED_BACKUP_CLOUD_SERVER: 'Cloud server backup is enabled',
    DISABLED_BACKUP_CLOUD_SERVER: 'Cloud server backup is disabled',
    BACKUP_UNAVAILABLE: 'Backup feature is currently unavailable.',
    TRIAL_SMS_CONTENT_NOT_EXIST:
        'The trial SMS content is unavailable. Please reach out to the administrator for assistance.',
    TRIAL_BRANDNAME_INVALID:
        'The Brandname is unavailable. Please reach out to the administrator for assistance.',
    USED_TRIAL_SMS_SERVICE: 'You have used trial SMS',
    DOMAIN_NOT_SUPPORT: 'Unsupported domain',
    SYSTEM_BUSY: 'The system is busy, please try again later',
    DOMAIN_CANNOT_REACTIVATED: 'The domain cannot be reactivated',
    PACKAGE_NOT_SUPPORT_UPGRADE: 'The package is not supported to upgrade',
    CANNOT_INSTALL_SSL_FOR_DOMAIN: 'These certs are invalid',
    CLOUD_STATUS_INVALID:
        'Your cloud status is currently unable to perform this action',
    LINKED_ACCOUNT_ALREADY_EXISTS:
        'This email address is already associated with a 1Byte account',
    OMISE: {
        CONFIRMED_AMOUNT_MISMATCH:
            'Payment Gateway Error: Final amount from payment channel does not match original amount charged',
        FAILED_FRAUD_CHECK:
            'Payment Gateway Error: Card was marked as fraudulent',
        FAILED_PROCESSING:
            'Payment Gateway Error: General payment processing failure',
        INSUFFICIENT_BALANCE:
            'Payment Gateway Error: Insufficient funds in the account or the card has reached the credit limit',
        INSUFFICIENT_FUND:
            'Payment Gateway Error: Insufficient funds in the account or the card has reached the credit limit',
        INVALID_ACCOUNT_NUMBER:
            'Payment Gateway Error: Valid account for payment method not found',
        INVALID_ACCOUNT:
            'Payment Gateway Error: Valid account for payment method not found',
        PAYMENT_CANCELLED: 'Payment Gateway Error: Payment cancelled by payer',
        PAYMENT_REJECTED: 'Payment Gateway Error: Payment rejected by issuer',
        STOLEN_OR_LOST_CARD: 'Payment Gateway Error: Card stolen or lost',
        TIMEOUT:
            'Payment Gateway Error: Payment provider did not respond in time',
        OMISE_SERVICE_ERROR:
            'Payment Gateway Error: Please try again, if this still happens, please contact support',
        INVALID_CHARGE: 'Payment Gateway Error: {message}',
    },
    CARD_MONTHLY_LIMIT_EXCEEDED:
        'The payment amount exceeds your card’s monthly limit',
    CONTRACT_NOT_FOUND: 'The Contract not found',
    TRANSACTION_ERROR: 'Transaction processing error',
    CONCURRENT_TRANSACTION:
        'You currently have another payment transaction in progress',
    PAYMENT_TRANSACTION_INVALID_STATUS:
        "Payment transaction must be in 'PENDING' or 'PROCESSING' status to perform this action",
    PAYMENT_TRANSACTION_CANNOT_CANCEL: `Payment transaction can only be cancelled after {minCancelHour} hour(s) since creation`,
    ORDER_IN_TRANSACTION:
        'This order is currently being processed by transaction {bulkPaymentId}. Please wait for the transaction to complete or cancel it before proceeding with the payment',
};
